import { DeleteConfirmationModal } from 'components/core-ui/DeleteConfirmationModal'

export const DeleteModal = ({ isModalOpen, closeModal, itemId, setShouldRefreshData }) => (
    <DeleteConfirmationModal
        isModalOpen={isModalOpen}
        actionUrl='/iam/external-partners/delegates/:id'
        content='Are you sure you want to deactivate this delegate? This action cannot be undone.'
        closeModal={closeModal}
        itemId={itemId}
        setShouldRefreshData={setShouldRefreshData}
        succesMessage='Delegate deactivated successfully'
        errorMessage='Failed to deactivate delegate.'
    />
)